<template>
  <div class="item">
    <div class="top">
      距结束:<span>{{item.countDown.d}}</span>天<span>{{item.countDown.h}}</span>时<span>{{item.countDown.m}}</span>分<span>{{item.countDown.s}}</span>秒
    </div>
    <div class="line"></div>
    <div class="center">
      <van-swipe @change="onChange" class="swipe" :autoplay="3000">
        <van-swipe-item class="goods-item" :key="goods[0].goods_id" v-for="goods in sliceArray(item.goods_list,2)">
          <div class="goods" @click="toDetail(item.for_type,goods[0].goods_id)">
             <div class="img"><img :src="goods[0].image" alt=""></div>
             <p class="name">{{goods[0].general_name}} {{goods[0].norms}}</p>
             <p class="company">{{goods[0].produce_unit}}</p>
             <p>数量：{{goods[0].quantity}}</p>
             <p v-if="item.userid === 1">单品价：<span v-delivery-price>¥{{float_change(goods[0].price)}}</span></p>
             <p v-else>单品价：<span>会员可见</span></p>
          </div>
          <div class="goods" v-if="goods[1]" @click="toDetail(item.for_type,goods[1].goods_id)">
            <div class="img"><img :src="goods[1].image" alt=""></div>
            <p class="name">{{goods[1].general_name}} {{goods[1].norms}}</p>
            <p class="company">{{goods[1].produce_unit}}</p>
            <p>数量：{{goods[1].quantity}}</p>
            <p v-if="item.userid === 1">单品价：<span v-delivery-price>¥{{float_change(goods[1].price)}}</span></p>
            <p v-else>单品价：<span>会员可见</span></p>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="line"></div>
    <div class="bottom">
      <div class="price-info">
        套装价：<template v-if="item.userid === 1"><span class="price" v-delivery-price><b>￥</b>{{float_change(item.jiage)}}</span>
        <span class="del-price" v-if="!isDeliveryFlag">￥{{float_change(item.shanchu_price)}}</span></template>
        <span v-else class="price">会员可见</span>
      </div>
      <goods-btn
        :btn-type="getGoodsType(item)"
        @openCart="openCart(item)"
      />
    </div>
    <!-- 促销套餐立即抢购购物车弹窗start -->
    <cc-promot-cart
      :isShowPopup="showCartPromot"
      :promotCartData="promotCartData"
      :height="556"
      getContainer="body"
      @close="showCartPromot=false"
      v-if="showCartPromot"
    ></cc-promot-cart>
    <!-- 促销套餐立即抢购购物车弹窗end -->
  </div>
</template>

<script>
import Vue from 'vue'
import { Swipe, SwipeItem, Toast } from 'vant'
import CommandMinxin from '@/mixins/command'
import CartStepMinxin from '@/mixins/cartStep'
import GoodsBtn from '../components/btn'
Vue.use(Swipe).use(SwipeItem)
export default {
  name: 'goods-item',
  components: { GoodsBtn },
  mixins: [CommandMinxin, CartStepMinxin],
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      current: 0,
      promotCartData: null,
      // 立即抢购加入购物车开关
      showCartPromot: false
    }
  },
  computed: {
    isDeliveryFlag () {
      // eslint-disable-next-line camelcase
      return +this.getLoadSettingStatus?.data?.is_delivery_flag === 1
    },
    getGoodsType () {
      return function (item) {
        if (item.userid) { // 登录
          if (item.is_view === 1) { // 区域经销
            return 1
          }
          if (item.stock * 1 === 0 || +item.now_time >= +item.end_date) { // 无套餐库存  或者已经结束
            return 3
          }
          return 2
        } else {
          return 0
        }
      }
    }
  },
  methods: {
    openCart (item) {
      if (item.userid === 0) {
        location.href = '/visitor/login'
        return
      }
      if (this.getLoadSettingStatus.data.is_delivery_flag === 1) {
        Toast('委托配送商品不参与促销套装')
        return false
      }
      this.showCartPromot = true
      this.promotCartData = {
        ...this.item,
        choose: 0,
        num: 1,
        step: 1
      }
      this.promotCartData.stock = +this.promotCartData.stock
    },
    onChange (index) {
      this.current = index
    },
    sliceArray (arr, size) {
      let newArr = []
      for (let i = 0; i < arr.length; i = i + size) {
        newArr.push(arr.slice(i, i + size))
      }
      return newArr
    },
    toDetail (type, id) {
      this.$router.push({
        path: '/goods-details',
        query: {
          goods_id: id,
          type: type
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.item{
  width: 355px;
  height: 249px;
  background:rgba(255,255,255,1);
  box-shadow:0px 1px 5px 0px rgba(230,229,229,0.7);
  border-radius:10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  .top{
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    span {
      min-width: 15px;
      height: 15px;
      border: 1px solid rgba(229, 229, 229, 1);
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin: 0 6px;
      border-radius: 4px;
      color: #EB2525;
    }
  }
  .center{
    flex:1;
    padding:10px 29px;
    .goods-item{
      display: flex;
      justify-content: space-between;
      .goods{
        width: 120px;
        .img{
          width: 78px;
          height: 71px;
          overflow: hidden;
          img{
            width: 100%;
          }
        }
        .name{
          @include ell();
          color: #333333;
          font-size: 14px;
        }
        .company{
          @include ell();
        }
      }
    }
  }
  .bottom{
    height: 40px;
    display: flex;
    padding: 0 10px;
    justify-content: space-between;
    align-items: center;
    .price-info{
      color:#555555;
      font-size: 12px;
      font-weight:500;
      .price{
        color:#EA2727;
        font-size: 18px;
        font-weight:400;
        b{
          font-size: 12px;
        }
      }
      .del-price{
        font-size: 12px;
        color: #777777;
        text-decoration: line-through;
        margin-left: 12px;
      }
    }
    .btn{
      background: var(--APP_theme_color);
      width: 65px;
      height: 24px;
      border-radius: 12px;
      color: #ffffff;
      @include center();
    }
  }
  .line {
    height: 1px;
    width: 100%;
    background: rgba(229, 229, 229, 1);
    transform: scaleY(0.5);
  }
}
  .swipe{
    height: 100%;
    /deep/{
      .van-swipe__indicator{
        width: 6px;
        height: 2px;
        background:#d2d2d2;
        opacity: 1;
        border-radius:1px;
      }
      .van-swipe__indicator--active{
        background: var(--APP_theme_color);
        width: 8px;
        height: 2px;
        border-radius: 1px;
      }
      .van-swipe__indicators{
        transform: translate(-50%, 10px);
      }
    }
  }
</style>
